import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import ColorPicker from '../common/colorPicker';
import { FieldErrorMessage } from './fieldErrorMessage';

class FormColorPicker extends Component {
  render() {
    const { id, label, subtext, required, validationErrorMessage, ...pprops } =
      this.props;

    return (
      <Form.Field id={id} required={required}>
        <label>{label}</label>
        <ColorPicker {...pprops} />
        {subtext && <div className="input-sub">{subtext}</div>}
        <FieldErrorMessage message={validationErrorMessage} />
      </Form.Field>
    );
  }
}

export default FormColorPicker;
